define('components/factory/models/ProductModel', [

], function() {

    var ProductModel = Backbone.Model.extend({
        parse: function(response) {
            var obj = null;

            if( response.error && response.product === null ) {
                this.set('error', response.error);
            } else {
                this.set('error', null);
                var forcedDatas = this.get('forcedDatas');

                obj = {
                    "currency": response.product.currency,
                    "wording": response.wording,
                    "quantity": [],
                    "product": {
                        "label": ( forcedDatas && forcedDatas.product && forcedDatas.product.resultLabel ) ? forcedDatas.product.resultLabel : response.product.resultLabel,
                        "arrivalTime": response.product.arrivalTime,
                        "href": ( forcedDatas && forcedDatas.product && forcedDatas.product.href ) ? forcedDatas.product.href : response.product.href,
                        "skus": []
                    }
                };

                obj.titleEqualSubtitle = obj.wording.title === obj.wording.subtitle;

                if( forcedDatas && forcedDatas.wording ) {
                    obj.wording = _.extend( obj.wording, forcedDatas.wording );
                }

                if( forcedDatas && forcedDatas.maxQuantity ) {
                    obj.maxQuantity = forcedDatas.maxQuantity;
                } else {
                    obj.maxQuantity = response.maxQuantity;
                }

                var priceFrom = 0.00;
                var capacityFrom = 0;
                var defaultSku = null;
                var lowestPriceSku = null;

                _.each( response.product.skus, _.bind( function( item, index ){
                    var shouldAddSku = true;

                    if( this.get('forcedSkus') ){
                        shouldAddSku = _.contains( this.get('forcedSkus'), item.skuCode );
                    }

                    if( this.get('blackListedSkus') ){
                        shouldAddSku = !_.contains( this.get('blackListedSkus'), item.skuCode );
                    }

                    if( shouldAddSku ){

                        var newItemDatas = null;

                        if( forcedDatas && forcedDatas.product && forcedDatas.product.skus ){
                            newItemDatas = _.findWhere( forcedDatas.product.skus, {skuCode: item.skuCode} );
                        }

                        if (newItemDatas) {
                            if (newItemDatas.optionValue) {
                                item.optionValue = newItemDatas.optionValue;
                            }

                            if (newItemDatas.novelty) {
                                item.novelty = newItemDatas.novelty;
                            }

                            if (newItemDatas.assets && newItemDatas.assets.packshot) {
                                item.assets.packshot = newItemDatas.assets.packshot;
                            }

                            if (newItemDatas.assets && newItemDatas.assets.swatch) {
                                item.assets.swatch = newItemDatas.assets.swatch;
                            }
                        }

                        if( item.selectedSku ) {
                            defaultSku = item.skuCode;
                        }

                        _.each( item.assets, _.bind( function( asset, key ){
                            if (asset) {
                                if (this.get('wsRoot').indexOf('get-quick-buy-product') !== -1 && (!newItemDatas || !newItemDatas.assets || !newItemDatas.assets[key]) ) {
                                    if( key === 'packshot' ) {

                                        // if (this.get('overridePackshotWithCover')) {
                                        if (this.get('overridePackshotWithCover')) {
                                          asset = item.coverHorizonMobile
                                        } else {
                                          if ( this.get('useNewShadowPackshot') ) {
                                              asset = item.packshotPDG ? item.packshotPDG : asset;
                                          } else if( this.get('useShadowPackshot') ) {
                                              asset = response.product.packshotPDG ? response.product.packshotPDG : asset;
                                          }
                                        }

                                        var tmp = asset.split('/');
                                        var i = _.indexOf( tmp, 'ep' );
                                        tmp[ i + 1 ] = this.get('assetsWidth');
                                        tmp[ i + 2 ] = this.get('assetsHeight');
                                        asset = tmp.join('/');
                                    }

                                    if (this.get('overridePackshotWithCover')) {
                                      item.assets[key] = asset;
                                    } else {
                                      item.assets[key] = this.get('base_url') + asset;
                                    }
                                } else {
                                    item.assets[key] = this.get('assets_url') + asset;
                                }
                            }
                        }, this) );

                        var availability = null;
                        try {
                            availability = $.parseJSON(item.availability);
                        } catch(err) {}

                        if( item.productPriceWithCurrency === null ) {
                            if( !availability ) {
                                availability = {};
                            }

                            availability.outOfStock = true;
                        }

                        var price = 0.00;
                        if (item.productPriceWithCurrency) {
                            price = item.productPriceWithCurrency.replace(/,/g, '.').replace(new RegExp("[^(0-9\.)]", "g"), '');
                            var splittedPrice = price.split('.');
                            if (splittedPrice[splittedPrice.length-1].length === 2) {
                                splittedPrice[splittedPrice.length-1] = '.' + splittedPrice[splittedPrice.length-1];
                            }
                            price = parseFloat( splittedPrice.join('') ).toFixed(2);
                        }

                        if( !priceFrom || parseFloat( price ) < priceFrom ) {
                            lowestPriceSku = item.skuCode;
                            priceFrom = price;
                            priceFromWithCurrency = item.productPriceWithCurrency;
                            capacityFrom = item.optionValue;
                        }

                        obj.product.skus.push({
                            "skuCode": item.skuCode,
                            "label": item.optionValue,
                            "price": price,
                            "productPriceWithCurrency": item.productPriceWithCurrency ? item.productPriceWithCurrency : null,
                            "availability": availability,
                            "assets": item.assets,
                            "category": item.category,
                            "clickTrackObject": item.clickTrackObject || null,
                            "productClickTrackObject": item.productClickTrackObject || null,
                            "hoverTrackObject": item.hoverTrackObject || null,
                            "isSelected": (this.get('defaultSku') && this.get('defaultSku') === item.skuCode)
                        });
                    }
                }, this) );

                for( var i = 0; i < obj.maxQuantity; i++ ){
                    obj.quantity.push({
                        "label": obj.wording.quantity + " " + (i + 1),
                        "value": (i + 1),
                        "selected": (i + 1 === this.get('quantity')) ? true : false
                    });
                }

                // If defaultSku not in sku list
                if( this.get('defaultSku') && obj.product && obj.product.skus && !_.findWhere( obj.product.skus, {"skuCode": this.get('defaultSku')} ) ){
                    this.set('defaultSku', null, {"silent": true});
                }

                // If no forced defaultSku use webservice default sku
                if( !this.get('defaultSku') && defaultSku !== null ) {
                    if( this.get('showPriceFrom') ) {
                        this.set('defaultSku', lowestPriceSku, {"silent": true});
                    } else {
                        this.set('defaultSku', defaultSku, {"silent": true});
                    }
                }

                // If no forced defaultSku and no webservice default sku use first sku
                if( !this.get('defaultSku') && obj.product.skus[0]){
                    obj.product.skus[0].isSelected = true;
                    this.set('defaultSku', obj.product.skus[0].skuCode);
                }

                if (obj.product.skus.length > 1) {
                    this.set('hasMultipleSkus', true);
                }

                if ( typeof obj.product.skus[0].assets.swatch === 'undefined' || obj.product.skus[0].assets.swatch === null ) {
                    this.set('hasCapacity', true);
                    this.set('hasSwatch', false);
                }else {
                    this.set('hasCapacity', false);
                    this.set('hasSwatch', true);
                }

                if( this.get('showPriceFrom') && priceFrom > 0 && obj.product.skus.length > 1 )  {
                    this.set('priceFrom', priceFromWithCurrency);
                    if( typeof obj.product.skus[0].assets.swatch === 'undefined' || obj.product.skus[0].assets.swatch === null ) {
                        this.set('capacityFrom', capacityFrom);
                    }
                    this.set('showPrice', false);
                }

                var description = obj.wording.description;
                var chars = this.get('cutDescriptionMaxChars') || 160;
                if (this.get('cutDescription') && description.length > chars) {
                    var shortDescription = description.substring(0, Math.max(description.indexOf(" ", chars), chars));
                    obj.wording.description = shortDescription + '...';
                }

                if ( !obj.wording.subtitle && obj.wording.productName ) {
                    obj.wording.subtitle = obj.wording.productName;
                }

                this.set('expandSwatch', (this.get('suffixClass') === "grid" && obj.product.skus.length > 1 && this.get('showSwatch')));
                this.set('hasUnavailableLayer', (this.get('suffixClass') === "grid" && obj.product.skus.length === 1));

            }

            if( this.get('priceWS') && obj !== null ) {
                this.afterFetch( obj );
                return {datas: this.get('datas')};
            } else {
                return {datas: obj};
            }

        },

        afterFetch: function( datas ) {

            var params = {
                    items: _.map( datas.product.skus, function( s ) { return {sku: s.skuCode}; } )
            };

            $.ajax({
                url: this.get('priceWS'),
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(params),
                // dataType: 'json',
                processData: false,
                success: _.bind( function( response ) {
                    _.each( datas.product.skus, function( s ) {
                        var o = response.response[s.skuCode];
                        if( !_.isUndefined( o ) ) {
                            if( o.stock > 0 ) {
                                var price = parseFloat( o.price.replace(new RegExp("[^(0-9\.)]", "g"), '') );
                                if( o.price !== 0 ) {
                                    s.price = price;
                                    s.productPriceWithCurrency = o.price;
                                    s.availability = {
                                        notForSale: false,
                                        available: true,
                                        outOfStock: false
                                    };
                                }
                                price = null;
                            } else {
                                s.availability = {
                                    outOfStock: true
                                };
                            }
                        }
                    });

                    this.set('datas', datas);
                }, this),
                error: _.bind( function() {
                    if( datas !== null ) {
                        _.each( datas.product.skus, function( s ) {
                            s.availability = {
                                outOfStock: true
                            };
                            s.price = 0.00;
                            s.productPriceWithCurrency = null;
                        });
                        this.set('datas', datas);
                    } else {
                        this.onError();
                    }
                }, this)
            });
        },

        onError: function() {
            this.parse({'error': {'text': 'Webservice is unavailable'}, 'product': null});
        },

        defaults: {
            viewId: "product-id",                   // Classic default viewId
            wsRoot: "",                             // Root of webservice
            priceWS: null,                          //URL OF PRICE WEBSERVICE
            codeY: "A0000000",                      // Code Y of the product, used for webservice
            suffixClass: "full",                    // Class css for default display
                                                    // -> "full" (popin-product)
                                                    // || "basic-simple" (video-product)
                                                    // || "basic-multi" (video-product)
                                                    // || "multi" (multi-product)
            customClass: null,                      // Add custom css class to view
            allowResponsive: false,                 // Add css class for responsive display
            hasMultipleSkus: false,                 // Toggle between select of span display
            hasSwatch: false,                       // Show / Hide swatch images
            hasCapacity: false,                     // Show / Hide capacity select
            showPriceCapacity: true,                // Show / Hide price in capacity select
            showPriceWithLabel: false,              // Show / Hide price in colorpicker
            showPackshot: true,                     // Show / Hide packshot
            overridePackshotWithCover: false,       // override Packshot With Cover image
            overridePriceWithSubtitlePlusPrice: false, // change "198 €" to "Parfum - 198 €"
            ecrinHorizonForceKnowmore: false,        // force display knowmore url even if in horizon mode
            useShadowPackshot: false,               // Use or not the new unique square packshot with shadow instead of the old one
            useNewShadowPackshot: false,               // Use or not the new unique square packshot with shadow instead of the old one
            showRetailers: false,                   // Show / Hide retailer select ( Should be set in application delegate )
            showDefaultRetailerOption: true,        // Show / Hide find retailer in retailer list
            olfactoryNotes: null,                   // Show / Hide olfactory notes list ( Should be set in application delegate )
            linkOnPackshot: false,                  // Add link over packshot
            showHashtag: true,                      // Show / Hide hashtag
            showTitle: true,                        // Show / Hide title
            showSubtitle: true,                     // Show / Hide subtitle
            showLabel: false,                       // Show / Hide product label
            showDescription: true,                  // Show / Hide product description
            cutDescription: false,                  // Cut the description to show only 3 lines
            cutDescriptionMaxChars: 160,            // Cut the description to show only a specified number of characters
            showKnowmore: true,                     // Show / Hide button Knowmore
            showBtnDiscover: false,                 // Show / Hide Button Discover
            showSwatchLabel: true,                  // Show / Hide Swatch label
            showSwatch: true,                       // Show / Hide Swatch image
            expandSwatch: false,                    // Toggle swatch display (overlay / classic)
            allowQuickBuy: true,                    // Show / Hide ecommerce block ( price, quantity, button quickbuy )
            onAddToCartCallback: function() {},     // Callback on js-maz-addtocart
            showHeaderPrice: false,                 // Show / Hide Price under title
            showPrice: true,                        // Show / Hide Price
            showPriceFrom: false,                   // Show / Hide Price (From X$ - X ml)
            showQuantity: true,                     // Show / Hide Quantity block
            typeFieldQuantity: "select",            // Type of field quantity ( "select" || "text" )
            showDelivery: true,                     // Show / Hide Delivery details
            showBtnAction: true,                    // Show / Hide QuickBuy Button
            actionUrl: null,                        // url (ex: popin product) or null (if null, add to cart with ajax submit)
            forcedSkus: null,                       // Filter skus of webservice response (if null, all skus are selected)
            blackListedSkus: null,                  // Remove specifics skus from webservice response (if null, no sku removed)
            defaultSku: null,                       // Default sku selected if null default sku is the first
            currentSku: null,                       // Current sku selected
            rollSku: null,                          // Tmp sku selected (on roll)
            swatchOpened: false,                    // Private
            datas: null,                            // All datas of product
            retailers: null,                        // List of retailers ( Should be set in application delegate )
            swatchFilters: null,                    // Add swatch filters ( Should be set in application delegate )
            currentFilter: "",                      // Default filter selected
            previousProductUrl: null,               // Url of previous popin product url
            nextProductUrl: null,                   // Url of next popin product url
            quantity: 1,                            // Max Quantity
            assetsWidth: "500",                     // Set the size of the asset width
            assetsHeight: "500",                    // Set the size of the asset height
            forcedDatas: {},                        // Allow to override all product datas
            currentSiteTitle: null,                 // Name of current website
            showDiscoverWhenUnavailble: false,      // Show Discover Button when product is unavailable
            isPopinProduct: false,                  // For tracking purpose
            positionInPage: 1,                      // Position of product view in page
            shouldTrackImpression: true,            // Track impression or not
            delegateTrackImpression: false,         // Delegate Track impression to another Component
            trackingImpression: null,               // TrackingImpression sent to other components
            error: null,                            // Classic Error
            isReady: false                          // Classic isReady
        },

        getCurrency: function() {
            return this.get('datas') ? ( this.get('datas').currency ? this.get('datas').currency : ( this.getCurrentSkuInfo().hoverTrackObject ? this.getCurrentSkuInfo().hoverTrackObject.ecommerce.currencyCode : null ) ) : null;
        },

        getPrice: function() {
            var sku = this.get('rollSku') ? this.get('rollSku') : this.get('currentSku');
            var price = "0.00";

            if( this.get('datas') ){
                price = _.findWhere( this.get('datas').product.skus, { skuCode: sku } ) ? _.findWhere( this.get('datas').product.skus, { skuCode: sku } ).price : "0.00";
            }

            return price;
        },

        getCurrentSkuInfo: function() {
            var sku = this.get('rollSku') ? this.get('rollSku') : this.get('currentSku');
            var obj = null;

            if( this.get('datas') ){
                obj = _.findWhere( this.get('datas').product.skus, { skuCode: sku } );
            }

            return obj;
        },

        getCurrentSkuInfoImpression: function() {
            var obj = this.getCurrentSkuInfo() && this.getCurrentSkuInfo().hoverTrackObject;

            if( obj && obj.ecommerce && obj.ecommerce.impressions && obj.ecommerce.impressions.length > 0 ) {
                obj.ecommerce.impressions[0].list = this.get('currentSiteTitle');
                obj.ecommerce.impressions[0].position = this.get('positionInPage');
            }

            return obj;
        },

        getSwatches: function() {
            return this.get('datas') ? this.get('datas').product.skus : null;
        },

        setCurrentSku: function( sku ) {
            var tmpDatas = this.get('datas');
            if( tmpDatas && tmpDatas.product && tmpDatas.product.skus && !_.findWhere( tmpDatas.product.skus, {"skuCode": sku} ) ){
                sku = this.get('defaultSku') ? this.get('defaultSku') : tmpDatas.product.skus[0].skuCode;
            }

            this.set('currentSku', sku);
        },

        setRollSku: function( sku ) {
            var tmpDatas = this.get('datas');
            if( tmpDatas && tmpDatas.product && tmpDatas.product.skus && !_.findWhere( tmpDatas.product.skus, {"skuCode": sku} ) ){
                sku = this.get('defaultSku') ? this.get('defaultSku') : tmpDatas.product.skus[0].skuCode;
            }

            this.set('rollSku', sku);
        }//,

        // getImpressionTrackObject: function() {
        //  var obj = this.getCurrentSkuInfo();

        //  return {
        //      ecommerce: {
        //          impressions: [
        //              {
        //                  price: obj.price,
        //                  name: "J'adore - Eau de Parfum",
        //                  variant: "Bottle 150 mL",
        //                  id: "F071586009",
        //                  position: this.get('positionInPage'),
        //                  category: "Fragrance/Women's Fragrance/J'adore/Fragrances",
        //                  list: "",
        //                  brand: "J'adore"
        //              }
        //          ]
        //      },
        //      event: "impressions"
        //  };
        // },

        // getProductClickTrackObject: function() {
        //  return {
        //      ecommerce: {
        //          click: {
        //              actionField: {
        //                  list: ""
        //              },
        //              products: [
        //                  {
        //                      price: "168.50",
        //                      name: "J'adore - Eau de Parfum",
        //                      variant: "Bottle 150 mL",
        //                      id: "F071586009",
        //                      position: this.get('positionInPage'),
        //                      category: "Fragrance/Women's Fragrance/J'adore/Fragrances",
        //                      brand: "J'adore"
        //                  }
        //              ]
        //          }
        //      },
        //      event: "productClick"
        //  };
        // },

        // getVirtualDetailTrackObject: function() {
        //  return {
        //      ecommerce: {
        //          detail: {
        //              products: [
        //                  {
        //                      id: $productId,
        //                      category: $productCategory,
        //                      price: $productPrice,
        //                      name: $productName,
        //                      brand: $productBrand,
        //                      variant: $productVariant
        //                  }
        //              ]
        //          }
        //      },
        //      event: 'virtualDetail'
        //  };
        // },

        // getAddToCartTrackObject: function() {
        //  return {
        //      ecommerce: {
        //          add: {
        //              products: [
        //                  {
        //                      quantity: 1,
        //                      price: "168.50",
        //                      name: "J'adore - Eau de Parfum",
        //                      variant: "Bottle 150 mL",
        //                      id: "F071586009",
        //                      category: "Fragrance/Women's Fragrance/J'adore/Fragrances",
        //                      brand: "J'adore"
        //                  }
        //              ]
        //          },
        //          currencyCode: "EUR"
        //      },
        //      event: "addToCart"
        //  };
        // }
    });

    return ProductModel;
});
